import './HeroImage.scss';
import { HeroImageProps } from './HeroImage.types';

const HeroImage = ({ heroImageUrl, position= 'center center' }: HeroImageProps) => {
  return (
    <div className="hero-image">
      {heroImageUrl && (
        <section
          className="hero-section d-flex flex-column position-relative"
          style={{ background: `url(${heroImageUrl}) ${position}`, backgroundSize: 'cover' }}
        ></section>
      )}
    </div>
  );
};

export default HeroImage;
